module.exports = __webpack_public_path__ + "assets/panels/powermaster-360R-b94f543e91f78f6e7eb193c82f868688.svg";